import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry
*/
import PropTypes from 'prop-types';
import React from 'react';
import useBrand from '../hooks/use-brand';
import useDevice from '../hooks/use-device';
import useCustomWFFonts from '../hooks/use-custom-wf-fonts';
import { getClasses } from '../../lib/style-utils/style-utils';
import { pluck } from '../../lib/prop-utils/prop-utils';
import styles from './LegacyButton.less';
var buttonTypes = ['plain', 'secondary', 'primary'];

var LegacyButton = function LegacyButton(props) {
  var brand = useBrand();
  var device = useDevice();
  var useWFFonts = useCustomWFFonts();

  var id = props.id,
      type = props.type,
      name = props.name,
      buttonType = props.buttonType,
      children = props.children,
      ariaLabel = props.ariaLabel,
      onClick = props.onClick,
      className = props.className,
      disabled = props.disabled,
      allowDisabledFocus = props.allowDisabledFocus,
      en = props.en,
      buttonRef = props.buttonRef,
      keepProps = _objectWithoutProperties(props, ["id", "type", "name", "buttonType", "children", "ariaLabel", "onClick", "className", "disabled", "allowDisabledFocus", "en", "buttonRef"]);

  var classes = [useWFFonts ? 'useWFFonts' : '', disabled ? 'disabled' : ''].concat(_toConsumableArray(buttonTypes.slice(0, buttonTypes.indexOf(buttonType) + 1)));
  var classNames = getClasses({
    styles: styles,
    classes: classes,
    brand: brand,
    device: device,
    className: className
  });

  var handleClick = function handleClick(event) {
    if (!disabled) {
      window._lastElementClicked = event.currentTarget;
      onClick && onClick(event);
    }

    type === 'submit' && event.preventDefault();
  };

  return /*#__PURE__*/React.createElement("button", _extends({
    id: id,
    name: name,
    type: type,
    "aria-label": ariaLabel,
    disabled: disabled && !allowDisabledFocus ? true : null,
    "aria-disabled": disabled && allowDisabledFocus ? true : null,
    onClick: handleClick,
    className: classNames,
    ref: buttonRef,
    "data-en": en
  }, pluck(['buttonRef', 'dispatch'], keepProps)), children);
};

LegacyButton.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  opensDialog: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  buttonType: PropTypes.string,
  ariaLabel: PropTypes.string,
  brand: PropTypes.string,
  en: PropTypes.string,
  allowDisabledFocus: PropTypes.bool
};
LegacyButton.defaultProps = {
  type: 'button',
  buttonType: 'plain',
  disabled: false,
  onClick: function onClick() {
    return undefined;
  },
  allowDisabledFocus: false
};
LegacyButton.displayName = 'LegacyButton';
export default LegacyButton;